import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\git\\fh-app\\fh-fe\\node_modules\\next-intl\\dist\\esm\\production\\shared\\NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter-sans\",\"weight\":[\"100\",\"200\",\"300\",\"400\",\"500\",\"600\",\"700\",\"800\",\"900\"],\"style\":[\"normal\",\"italic\"],\"display\":\"swap\",\"fallback\":[\"system-ui\",\"sans-serif\"],\"preload\":true,\"subsets\":[\"latin\"]}],\"variableName\":\"interSans\"}");
;
import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\node_modules\\bootstrap\\dist\\css\\bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\node_modules\\react-photo-view\\dist\\react-photo-view.css");
;
import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\node_modules\\react-datepicker\\dist\\react-datepicker.css");
;
import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\node_modules\\swiper\\swiper.css");
;
import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\node_modules\\animate.css\\animate.css");
;
import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\src\\app\\page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\git\\fh-app\\fh-fe\\src\\components\\alerts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "D:\\git\\fh-app\\fh-fe\\src\\components\\analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\git\\fh-app\\fh-fe\\src\\components\\cooking-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\git\\fh-app\\fh-fe\\src\\components\\footer-navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\git\\fh-app\\fh-fe\\src\\components\\loading.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\git\\fh-app\\fh-fe\\src\\components\\navigation\\navigation-loader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\git\\fh-app\\fh-fe\\src\\store\\clientInitializer.tsx");
;
import(/* webpackMode: "eager" */ "D:\\git\\fh-app\\fh-fe\\src\\styles\\globals.scss");
